export const reformatDates = (date: any) => {
  return date ? date?.split("-").reverse().join("-") : null;
};
